// src/components/PdfButton.js
import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
//import "bootstrap/dist/css/bootstrap.min.css";
// import '../Styles/confirmation.css';
//import "./conformpage.css";

const PdfButton = ({ data, cms, carrier }) => {
  const handleDownloadPdf = () => {
    /* const doc = new jsPDF();
    doc.text("Payment Confirmation", 10, 10);
    doc.text(`Confirmation Code: ${data.confirmationCode}`, 10, 20);
    doc.text(`Name: ${data.name}`, 10, 30);
    doc.text(`Payment Amount: $${data.amount}`, 10, 40);
    doc.text(`Scheduled For: ${data.date}`, 10, 50);
    doc.save("confirmation.pdf");*/

    // Store references to elements that need to be removed
    const elementsToExclude = document.querySelectorAll(".exclude-in-print");
    const elementsToInclude = document.querySelectorAll(".show-in-download");

    // Hide or remove the elements you want to exclude from the page
    elementsToExclude.forEach((element) => {
      element.style.display = "none"; // Temporarily hide the elements
    });

    //Show elements in pdf
    elementsToInclude.forEach((element) => {
      element.style.display = "block"; // Temporarily include the elements
    });

    // Select the entire page or a specific element to capture
    const element = document.body; // You can also use specific element like `document.getElementById('content')`

    html2canvas(element).then((canvas) => {
      // Restore the excluded elements back to the page
      elementsToExclude.forEach((element) => {
        element.style.display = ""; // Restore the original display style
      });
      elementsToInclude.forEach((element) => {
        element.style.display = "none"; // Restore the original display style
      });

      // Create a new jsPDF instance
      const doc = new jsPDF();

      // Add the canvas image to the PDF
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, canvas.width / 6, canvas.height / 6); // Adjust scaling as needed

      // Save the PDF
      doc.save("payment_confirmation.pdf");
    });
  };

  return (
    <button
      className={`btn ${carrier === "bcbsaz" ? "btn-outline-secondary" : "btn-primary"} btn-lg exclude-in-print`}
      onClick={handleDownloadPdf}
    >
      {cms.label_download_pdf}
    </button>
  );
};

export default PdfButton;
